<main class="main-content flex flex-col items-center justify-center">
  <h1>Jatakk – Vil Depotbiblioteket ha boka?</h1>
  <mat-card appearance="raised" class="mat-drawer-container info">
    <mat-card-content>
      <p>
        Dette er en tjeneste for bibliotek som ønsker å avlevere bøker til
        Depotbiblioteket.
      </p>
      <p>
        Les strekkoden på bokas ISBN, og få tilbakemelding om boka skal sendes
        oss eller ikke. Bøker uten ISBN må søkes opp i
        <a href="https://depotbiblioteket.no/" target="_blank">
          Depotbiblioteket
        </a>
      </p>
      <p class="warn">
        OBS: Tjenesten kan kun brukes på bøker med ISBN, og kan ikke brukes på
        film eller lydbøker.
      </p>
    </mat-card-content>
  </mat-card>
  <form
    class="isbnForm flex items-center justify-center gap-4"
    [formGroup]="isbnForm"
    (ngSubmit)="onSubmit()"
    novalidate
  >
    <mat-form-field>
      <mat-label>ISBN</mat-label>
      <input
        #input
        id="isbn"
        matInput
        autocomplete="off"
        formControlName="isbn"
        required
      />
      @if (isbnFormControl.hasError('required')) {
        <mat-error>
          ISBN er et
          <strong>påkrevd</strong> felt
        </mat-error>
      } @else if (isbnFormControl.hasError('invalidIsbn')) {
        <mat-error>
          ISBN er
          <strong>ugyldig</strong>
        </mat-error>
      }
    </mat-form-field>
    <button
      id="submitButton"
      type="submit"
      [disabled]="!isbnForm.valid"
      mat-raised-button
      color="primary"
    >
      Søk
    </button>
  </form>
  @if (hasResult || error) {
    <div class="resultContainer flex flex-col items-center justify-center">
      @if (error) {
        <div>
          {{ error }}
        </div>
      } @else if (hasResult && !isLoading) {
        <div id="result" class="flex items-end gap-4">
          {{ createLabel(shouldSend) }}
          @if (shouldSend === result.Yes) {
            <mat-icon class="thumb-up">thumb_up</mat-icon>
          } @else {
            <mat-icon color="warn">thumb_down</mat-icon>
          }
        </div>
      }
    </div>
  }
  @if (isLoading) {
    <mat-spinner [diameter]="50"></mat-spinner>
  }
  <span class="read-more"
    >Les mer om overføring av publikasjoner til Depotbiblioteket
    <a
      href="https://bibliotekutvikling.no/lan-fra-nasjonalbiblioteket/depotbiblioteket/overforing-av-publikasjoner-til-depotbiblioteket/"
      target="_blank"
      >her.</a
    >
  </span>
</main>
